import { Location } from '@app/shared/routes';

const UserListLocation = new Location({ path: '/user-list' });

export { UserListLocation };
